var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/comments/attach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3042784,23.2403754 C13.9412554,25.5924059 10.1193725,25.5924059 7.75634944,23.2403754 C5.41455019,20.897835 5.41455019,17.1029158 7.75634944,14.7603754 L16.254232,6.32037541 C18.0299059,4.55987486 20.8945095,4.55987486 22.6701834,6.32037541 C23.5210888,7.16017706 24,8.30540081 24,9.50037541 C24,10.69535 23.5210888,11.8405738 22.6701834,12.6803754 L14.8729507,20.4203754 C14.3087435,20.9914005 13.5390907,21.3128235 12.7359685,21.3128235 C11.9328463,21.3128235 11.1631935,20.9914005 10.5989862,20.4203754 C10.0335982,19.8574698 9.7158013,19.0928298 9.7158013,18.2953754 C9.7158013,17.497921 10.0335982,16.733281 10.5989862,16.1703754 L15.5435728,11.2703754 C15.6375433,11.1757191 15.7654598,11.1224762 15.8989024,11.1224762 C16.0323449,11.1224762 16.1602615,11.1757191 16.254232,11.2703754 L16.7947333,11.8003754 C16.8894776,11.8942587 16.9427698,12.0220566 16.9427698,12.1553754 C16.9427698,12.2886942 16.8894776,12.4164921 16.7947333,12.5103754 L11.8501468,17.4103754 C11.4318577,17.9120621 11.4664737,18.6498775 11.9299007,19.1102736 C12.3933277,19.5706696 13.1320115,19.6010963 13.6317994,19.1803754 L21.4290321,11.4503754 C21.9479837,10.9359261 22.2398684,10.2357654 22.2398684,9.50537541 C22.2398684,8.77498545 21.9479837,8.07482472 21.4290321,7.56037541 C20.3436979,6.48237127 18.5907268,6.48237127 17.5053925,7.56037541 L8.98749143,16.0003754 C7.33315508,17.6589062 7.33315508,20.3418446 8.98749143,22.0003754 C10.6690991,23.64822 13.3615009,23.64822 15.0431086,22.0003754 L20.6983543,16.3903754 C20.8975628,16.1920392 21.2198143,16.1920392 21.4190228,16.3903754 L21.9495149,16.9203754 C22.0462819,17.0111087 22.1011742,17.1377895 22.1011742,17.2703754 C22.1011742,17.4029613 22.0462819,17.5296421 21.9495149,17.6203754 L16.3042784,23.2403754 Z",
    id: "Icon-color",
    fill: "#192233"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.a54f8728.svg";
export { ForwardRef as ReactComponent };